<template>
  <div
      data-app
      class="wrapper"
      :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive },
    ]"
  >
    <side-bar
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
    >
      <div style="margin-top: 10%;" class="user">
        <img
            style="display: block; margin: auto; padding: 0 60px;"
            :src="sidebarLogo"
        />
      </div>
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>
      <template slot="links">

        <!-- _!isRegularize && !isYaraLtm && !isDemo /visao-geral_ -->
        <!-- <sidebar-item
            v-if="!isIma && !isDashboardSelect(tenant) && validateRoles('/visao-geral')"
            :link="{
            name: $t('drawer.dashboard'),
            icon: 'grid-large',
            path: '/visao-geral',
          }"
        >
        </sidebar-item> -->

        <!-- isRegularize || isYaraLtm || isDemo /visao-geral -->
        <sidebar-item
            v-if="(isDashboardSelect(tenant) || isYara) && (!isIma && !isIpmc && !isSesam) && (validateRoles('/visao-geral') || validateRoles('/eficiencia'))"
            :link="{
            name: $t('drawer.dashboard'),
            icon: 'grid-large',
          }"
        >
          <sidebar-item
              v-if="(isDashboardSelect(tenant) || isYara) && validateRoles('/visao-geral')"
              :link="{
              name: $t('drawer.overview'),
              slug: 'configuracoes',
              img: true,
              path: '/visao-geral',
            }"
          >
          </sidebar-item>

          <sidebar-item
              v-if="(isDashboardSelect(tenant) || isYara) && validateRoles('/eficiencia')"
              :link="{
              name: $t('drawer.efficiency'),
              slug: 'configuracoes',
              img: true,
              icon: 'finance',
              path: '/eficiencia',
            }"
          >
          </sidebar-item>
        </sidebar-item>

        <!-- Universal historico-conversas -->
        <sidebar-item
            v-if="validateRoles('/historico-conversas') && (!isIma && !isIpmc && !isSesam)"
            :link="{
            name: $t('drawer.chatHistory'),
            icon: 'history',
            path: '/historico-conversas',
          }"
        >
        </sidebar-item>

        <!-- Tenant busca-por-mensagens -->
        <sidebar-item
            v-if=" (!isIma && !isIpmc && !isSesam) && searchMessageDashboard (tenant) && validateRoles('/busca-por-mensagens')"
            :link="{
            name: $t('drawer.searchMessages'),
            icon: 'account-search',
            path: '/busca-por-mensagens',
          }"
        >
        </sidebar-item>

        <!-- isInss Curadoria e Mensagens não entendidas  -->
        <sidebar-item v-if="(isInss || isDataPrev || isDemo || isCedae || isSefMg || isYara || isYaraLtm || isDanese || isEds || isExtreme) && (!isIma && !isIpmc && !isSesam)"
                      :link="{
            name: $t('curatorship.curatorship'),
            icon: 'filter',
          }"
        >
          <!-- Guia Dashboard Curadoria -->
          <sidebar-item
              v-if="validateRoles('/curadoria')"
              :link="{
              name: $t('curatorship.dashboard'),
              icon: 'grid-large',
              path: '/curadoria',
            }"
          >
          </sidebar-item>

          <!-- Mensagens não entendidas  -->
          <sidebar-item
              v-if="validateRoles('/mensagens-nao-entendidas')"
              :link="{
              name: $t('drawer.messagesNotUnderstood'),
              icon: 'message-bulleted-off',
              path: '/mensagens-nao-entendidas',
            }"
          >
          </sidebar-item>
        </sidebar-item>

        <!-- isInss Análise por Serviço Entregue -->
        <sidebar-item v-if="(isInss || isDemo || isCedae || isSefMg || isYara || isYaraLtm || isExtreme) && (!isIma && !isIpmc && !isSesam) && validateRoles('/analise-por-servico-entregue')"
                      :link="{
            name: $t('drawer.analysisPerServiceDelivered'),
            icon: 'chart-box-outline',
            path: '/analise-por-servico-entregue'
          }"
        ></sidebar-item>

        <sidebar-item
            v-if="(!isIma && !isIpmc && !isSefMg && !isSesam && !isExtreme) && validateRoles('/jornada-do-operador')"
            :link="{
            name: $t('drawer.operatorsJourney'),
            icon: 'timeline-clock',
            path: '/jornada-do-operador',
          }"
        >
        </sidebar-item>

        <!-- isInss /auditoria-atendimento -->
        <sidebar-item
            v-if="(isInss || isDataPrev || isDemo) && (!isIma && !isIpmc && !isSesam) && validateRoles('/auditoria-atendimento')"
            :link="{
            name: $t('drawer.eventAuthHistory'),
            icon: 'account-box-multiple',
            path: '/auditoria-atendimento',
          }"
        >
        </sidebar-item>

        <sidebar-item
            v-if="(isDataPrev || isSefMg || isDemo) && (!isIma && !isIpmc && !isSesam) && validateRoles('/log-acesso')"
            :link="{
            name: $t('drawer.accessLog'),
            icon: 'account-clock',
            path: '/log-acesso',
          }"
        >
        </sidebar-item>

        <!-- isInss /historico-produtividade -->
        <sidebar-item
            v-if="(isInss || isDemo) && (!isIma && !isIpmc && !isSesam) && validateRoles('/historico-produtividade')"
            :link="{
            name: $t('drawer.productivityHistory'),
            icon: 'account-details',
            path: '/historico-produtividade',
          }"
        >
        </sidebar-item>

        <sidebar-item
            v-if="(!isIma && !isIpmc && !isSesam && !isExtreme) && validateRoles('/templates')"
            :link="{name: $t('drawer.proactiveNotification'), icon: 'bell'}">
          <sidebar-item
              :link="{
              name: $t('drawer.templates'),
              icon: 'message-reply',
              path: '/templates',
            }"
          >
          </sidebar-item>
          <sidebar-item
              v-if="validateRoles('/campanha-desempenho-geral')"
              :link="{
              customIcon: true,
              name: $t('drawer.campaignPerformance'),
              path: '/campanha-desempenho-geral',
            }"
          >
          </sidebar-item>
          <sidebar-item
              v-if="validateRoles('/campanhas')"
              :link="{
              name: $t('drawer.campaign'),
              icon: 'bullhorn',
              path: '/campanhas',
            }"
          >
          </sidebar-item>
          <sidebar-item
              v-if="validateRoles('/lista-campanhas')"
              :link="{
              customIcon: true,
              name: $t('drawer.campaignFiredList'),
              path: '/lista-campanhas',
            }"
          >
          </sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="(isIma || isIpmc || isSesam) && validateRoles('/templates')"
          :link="{
          name: $t('drawer.templates'),
          icon: 'message-reply',
          path: '/templates',
        }">
        </sidebar-item>
        <sidebar-item v-if="(isIma || isIpmc || isSesam) && validateRoles('/campanha-desempenho-geral')" :link="{
          customIcon: true,
          name: $t('drawer.campaignPerformance'),
          path: '/campanha-desempenho-geral',
        }">
        </sidebar-item>
        <sidebar-item v-if="(isIma || isIpmc || isSesam) && validateRoles('/campanhas')" :link="{
          name: $t('drawer.campaign'),
          icon: 'bullhorn',
          path: '/campanhas',
        }">
        </sidebar-item>
        <sidebar-item v-if="(isIma || isIpmc || isSesam) && validateRoles('/lista-campanhas')" :link="{
          customIcon: true,
          name: $t('drawer.campaignFiredList'),
          path: '/lista-campanhas',
        }">
        </sidebar-item>
        <sidebar-item v-if="(isIma || isIpmc || isSesam)" :link="{
          customIcon: true,
          name: $t('activeContacts.activeContacts'),
          path: '/contatos-ativos',
        }">
        </sidebar-item>
        <sidebar-item
            v-if="(!isIma && !isIpmc && !isSesam) && (validateRoles('/workspaces') || (validateRoles('/edicao-simplificada') && (isDemo || isRegularize)))"
            :link="{
            name: 'Chat Builder',
            icon: 'lan',
            path: '/snapshots',
          }"
        >
          <sidebar-item
              v-if="(!$route.meta.hideFooter ) && validateRoles('/workspaces')"
              :link="{
              name:  'Workspaces',
              icon: 'folder-multiple',
              path: '/workspaces',
            }"
          >
          </sidebar-item>
          <sidebar-item
              v-if="(!$route.meta.hideFooter ) && validateRoles('/edicao-simplificada') && (isDemo ||
              isRegularize)"
              :link="{
              name:  $t('drawer.simplifiedEditingChatbuilder'),
              icon: 'playlist-edit',
              path: '/edicao-simplificada',
            }"
          >
          </sidebar-item>
        </sidebar-item>

        <sidebar-item
            v-if="(validateRoles('/configuracoes-usuario-perfil') || validateRoles('/users')) && (isDemo ||
              isRegularize)"
            :link="{
            name: $t('managementAccess.AccessManagement'),
            slug: 'gestao',
            img: true,
          }"
        >
          <sidebar-item
              v-if="validateRoles('/configuracoes-usuario-perfil') && (isDemo ||
              isRegularize)"
              :link="{
              name: $t('managementAccess.usersProfile'),
              path: '/configuracoes-usuario-perfil',
            }"
          >
          </sidebar-item>
          <sidebar-item
              v-if="validateRoles('/users') && (isDemo ||
              isRegularize)"
              :link="{
              name: $t('managementAccess.users'),
              path: '/users',
            }"
          >
          </sidebar-item>
          <!-- <sidebar-item
            v-if="isHidden"
            :link="{
              name: $t('managementAccess.functionalities'),
              path: '/configuracoes-funcionalidades',
            }"
          >
          </sidebar-item> -->
        </sidebar-item>

        <sidebar-item
            v-if="!isIma && !isIpmc && !isSesam"
            :link="{
            name: $t('drawer.settings.title'),
            slug: 'configuracoes',
            img: true,
          }"
        >
          <sidebar-item
              v-if="validateRoles('/canal-web')"
              :link="{
              name: $t('drawer.units.subitems.webChannel'),
              path: '/canal-web',
            }"
          >
          </sidebar-item>

          <sidebar-item
              v-if="validateRoles('/consulta-usuario-teams') && isDemo"
              :link="{
              name: $t('drawer.verifyTeamsUserService'),
              path: '/consulta-usuario-teams',
            }"
          >
          </sidebar-item>

          <sidebar-item
              v-if="validateRoles('/lista-assistentes')"
              :link="{
              name: $t('drawer.settings.subitems.assistantList'),
              slug: 'configuracoes',
              img: true,
              path: '/lista-assistentes',
            }"
          >
          </sidebar-item>

          <sidebar-item
              v-if="hiddenProvider && validateRoles('/provider-autenticacao')"
              :link="{
              name: $t('drawer.authentications.subitems.authentications'),
              slug: 'autenticacoes',
              img: true,
              path: '/provider-autenticacao',
            }"
          >
          </sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>

    <div class="main-panel fixBackground">
      <top-navbar></top-navbar>
      <div
          :class="{ content: !$route.meta.hideContent }"
          @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter && !isIma && !isIpmc && !isSesam"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
// import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'

import TopNavbar from './Dashboard/Layout/TopNavbar.vue'
import ContentFooter from './Dashboard/Layout/ContentFooter.vue'
import MobileMenu from './Dashboard/Layout/Extra/MobileMenu.vue'
import UserMenu from './Dashboard/Layout/Extra/UserMenu.vue'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'

function reinitScrollbar () {
  let docClasses = document.body.classList
  docClasses.add('perfect-scrollbar-off')
}

export default {
  components: {
    TopNavbar,
    ContentFooter,
    MobileMenu,
    UserMenu
  },
  data () {
    return {
      sidebarLogo: '',
      sidebarBackgroundColor: 'black',
      sidebarBackground: '',
      sidebarBackgroundImage: '',
      sidebarMini: true,
      sidebarImg: true,
      userRole: this.$store?.state?.roles,
      tenant: ''
    }
  },
  mixins: [isTenantMixin],
  computed: {
    ...mapFields('selectedAssistant', ['assistantId']),
    ...mapGetters('auth', ['user']),
    hiddenProvider () {
      let currentUrl = window.location.href
      let titleRegex = /(http:\/\/)?(https:\/\/)?[^-]*-([^-]+)-.*/
      let result = currentUrl.match(titleRegex)?.length >= 3 ? currentUrl.match(titleRegex)[3] : null
      let tenants = ['jucerja', 'gr1d', 'yara', 'yarabr']
      return !tenants.includes(result)
    }
  },
  methods: {
    toggleSidebar () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    minimizeSidebar () {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    isDashboardSelect (type) {
      const tenants = {
        regularize: true,
        yaraltm: true,
        cedae: true,
        demo: true,
        ima: true,
        sefmg: true,
        eds: true,
        danese: true,
        dataprev: true,
        extreme: true,
        default: false
      }
      return tenants[type] || tenants.default
    },
    searchMessageDashboard (type) {
      const tenants = {
        regularize: true,
        cedae: true,
        yaraltm: true,
        sefmg: true,
        demo: true,
        ima: true,
        inss: true,
        danese: true,
        eds: true,
        extreme: true,
        default: false
      }
      return tenants[type] || tenants.default
    },

    validateRoles (url) {
      if (this.user) {
        if (this.tenant !== 'sefmg' && this.tenant !== 'regularize' && this.tenant !== 'dataprev') return true
        return this.user?.functions?.find((item) => item === url)
      }

      return false
    }
  },
  updated () {
    reinitScrollbar()
  },
  mounted () {
    reinitScrollbar()
  },
  created () {
    this.availableChatBuilder = this.tenant === 'yara'
    this.sidebarBackgroundImage = this.isIma || this.isIpmc ? './img/rocketchat-bg.jpeg' : './img/sidebar-background.jpg'
    this.sidebarBackground = this.isIma || this.isIpmc ? 'rocketred' : 'green'
    this.sidebarLogo = this.isIma || this.isIpmc ? './img/rocketchat-logo.png' : './img/eds-logo.png'
  },
  watch: {
    sidebarMini () {
      this.minimizeSidebar()
    }
  }
}
</script>
<style lang='scss'>
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.main-panel.fixBackground {
  overflow: hidden !important;
}
.drawerVisual {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
}

.mdi-chart-box-outline::before {
  transform: rotate(90deg);
}

.mdi-chart-box-outline + p {
  font-size: 13.5px !important;
}
</style>
